module.exports = __webpack_public_path__ + "static/media/threeBar.fb26b07d.svg";